export const orange900 = '#802600';
export const orange800 = '#9F3300';
export const orange700 = '#BF4000';
export const orange600 = '#DF4F00';
export const orange500 = '#FF5E00';
export const orange400 = '#FF8E4D';
export const orange300 = '#FFBC80';
export const orange200 = '#FFD7B2';
export const orange100 = '#FFF3E5';
export const orange050 = '#FFF9F2';
export const blue900 = '#081F86';
export const blue800 = '#0F2AA7';
export const blue700 = '#1B39C5';
export const blue600 = '#3352E1';
export const blue500 = '#4563EC';
export const blue400 = '#7188EF';
export const blue300 = '#9AA9F2';
export const blue200 = '#D1D8FA';
export const blue100 = '#ECEFFD';
export const blue050 = '#F3F5FF';
export const green900 = '#004731';
export const green800 = '#026747';
export const green700 = '#07835B';
export const green600 = '#0FA777';
export const green500 = '#0FB682';
export const green400 = '#40CDA1';
export const green300 = '#8DEACB';
export const green200 = '#BBF2E0';
export const green100 = '#E3F8F1';
export const green050 = '#F1FCF8';
export const yellow900 = '#946F00';
export const yellow800 = '#B28900';
export const yellow700 = '#D1A000';
export const yellow600 = '#E4B301';
export const yellow500 = '#F9C402';
export const yellow400 = '#FCD22C';
export const yellow300 = '#FDDF5E';
export const yellow200 = '#FFF3B5';
export const yellow100 = '#FEF6D0';
export const yellow050 = '#FFFBE7';
export const red900 = '#4E0101';
export const red800 = '#7E0404';
export const red700 = '#A80D0D';
export const red600 = '#C51111';
export const red500 = '#E71313';
export const red400 = '#FA6B6B';
export const red300 = '#FDA8A8';
export const red200 = '#FECDCD';
export const red100 = '#FFE6E6';
export const red050 = '#FFF1F2';
export const grey950 = '#171717';
export const grey900 = '#222222';
export const grey800 = '#424242';
export const grey700 = '#656565';
export const grey600 = '#7B7B7B';
export const grey500 = '#9B9B9B';
export const grey400 = '#AFAFAF';
export const grey300 = '#C2C2C2';
export const grey200 = '#D6D6D6';
export const grey100 = '#E5E5E5';
export const grey050 = '#F9F9F9';
export const grey075 = '#F0F0F0';
export const grey025 = '#FBFBFB';
export const blackOpacity50 = 'rgba(0, 0, 0, 0.5)';
export const blackOpacity40 = 'rgba(0, 0, 0, 0.4)';
export const blackOpacity20 = 'rgba(0, 0, 0, 0.2)';
export const blackOpacity15 = 'rgba(0, 0, 0, 0.15)';
export const blackOpacity10 = 'rgba(0, 0, 0, 0.1)';
export const black = '#000000';
export const whiteOpacity75 = 'rgba(255, 255, 255, 0.75)';
export const white = '#FFFFFF';
export const transparent = 'transparent';
export const graphDarkPurple = '#25002d';
export const graphBlue = '#7088f0';
export const graphDarkBlue = '#0221A4';
export const graphYellow = '#efcc8a';
export const graphLightBlue = '#79bae4';
export const graphLightGreen = '#d3e6a0';
export const graphOrange = '#efa265';
export const graphPurple = '#6f1fc2';
export const graphRed = '#ee6a59';
export const graphTeal = '#a6dfd7';
export const graphPlum = '#8b5a8c';
export const primary = '#4563EC';
export const primarySidenav = '#7188EF';
export const primary100 = '#ECEFFD';
export const primary200 = '#D1D8FA';
export const primary400 = '#7188EF';
export const primary500 = '#4563EC';
export const primary600 = '#3352E1';
export const primary700 = '#1B39C5';
